import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-20 md:py-28 bg-background-900">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-white text-center mb-12">
          瓜友热评
        </h2>
        <div className="flex flex-col gap-8">
          {commentsData.map((comment, idx) => (
            <div
              key={comment.id}
              className="flex flex-col md:flex-row gap-0 md:gap-0 relative"
            >
              <div className={`md:w-1/3 flex justify-center md:justify-end md:pr-0 ${idx === 0 ? '' : ''}`}>
                <div className="w-24 h-24 md:w-28 md:h-28 rounded-2xl overflow-hidden md:-mr-10 relative z-10 border-2 border-white/10">
                  <img
                    src={comment.avatar}
                    alt={comment.author}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div className="md:w-2/3 bg-background-800/80 rounded-2xl p-6 md:p-8 md:pl-16 mt-[-30px] md:mt-0">
                <div className="text-accent-400 text-4xl font-serif mb-3 leading-none">&ldquo;</div>
                <p className="text-white/85 text-sm md:text-base leading-relaxed mb-5">
                  {comment.content}
                </p>
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-white text-sm font-medium">{comment.author}</p>
                    <p className="text-white/40 text-xs">{comment.role}</p>
                  </div>
                  <span className="px-4 py-1.5 bg-accent-500/15 text-accent-400 text-xs font-medium rounded-full">
                    91吃瓜用户
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}